"use client";
import axios from "@/lib/axios";
import { apis } from "@/static/apis/apis";
import { Axios } from "axios";
import toast from "react-hot-toast";

export const postUserRate = async (
  data: {
    user_being_liked: number;
    advertisement: number;
    rate: number;
    notification: number;
  },
  axiosAuth: Axios
) => {
  try {
    let val = await axiosAuth.post(apis.rate.postRate, data);
    toast.success("رای شما با موفقیت ثبت شد")
    return val;
  } catch (error: any) {
    console.error("Error fetching data:", error.message);
    // console.error("sadge")
    return undefined;
  }
};
